/*
 * pdp-details.js
 * ---------------------------------------------------------------------------
 * Light open/close height animation for the "Product details" collapsible
 * (custom_liquid block on the bamboo-TP PDP). Native <details> snaps open with
 * no transition, so we intercept the summary toggle and animate the body's
 * height both ways. Progressive enhancement: if this script never runs (or the
 * user prefers reduced motion) the element still works as a plain <details>.
 * ---------------------------------------------------------------------------
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 260; // ms

  document.querySelectorAll('details.pdp-details').forEach(function (details) {
    if (details.dataset.animInit) return;
    details.dataset.animInit = '1';

    var summary = details.querySelector('summary');
    var body = details.querySelector('.pdp-details__body');
    if (!summary || !body || reduceMotion) return; // leave native toggle in place

    var animating = false;

    summary.addEventListener('click', function (event) {
      event.preventDefault();       // take over from the native instant toggle
      if (animating) return;
      if (details.open) collapse();
      else expand();
    });

    function expand() {
      animating = true;
      details.open = true;          // reveal the body so we can measure it
      animateHeight(0, body.scrollHeight, function () {
        animating = false;
      });
    }

    function collapse() {
      animating = true;
      animateHeight(body.scrollHeight, 0, function () {
        details.open = false;       // hide only after the collapse finishes
        animating = false;
      });
    }

    function animateHeight(from, to, done) {
      var finished = false;
      function finish() {
        if (finished) return;       // run once — from either the event or the safety timer
        finished = true;
        body.removeEventListener('transitionend', onEnd);
        window.clearTimeout(safety);
        body.style.transition = '';
        body.style.height = '';
        body.style.overflow = '';
        done();
      }
      function onEnd(e) {
        // Only our own height transition — ignore transitions bubbling up from
        // descendants of the description body, which would end the anim early.
        if (e.target !== body || e.propertyName !== 'height') return;
        finish();
      }
      body.style.overflow = 'hidden';
      body.style.height = from + 'px';
      requestAnimationFrame(function () {
        body.style.transition = 'height ' + DURATION + 'ms ease';
        body.style.height = to + 'px';
      });
      body.addEventListener('transitionend', onEnd);
      // Fallback: if the height never actually transitions (from === to on an
      // empty body, or a missed event) release the lock so `animating` can't
      // stay stuck and freeze the toggle.
      var safety = window.setTimeout(finish, DURATION + 80);
    }
  });
})();
